import Ajax from '../../../../common/js/Ajax.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import TippspielWidget from '../TippspielWidget.js';

import TEMPLATE from './ScoresWidget.hbs';

export default class ScoresWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}

	onLoginReady() {
		Ajax.rpc('/scores', scores => {
			this.$widget.html(TEMPLATE(scores));
		}, error => {
			MessageUtils.error(this.$widget, TippspielWidget.getFailedMessage(), error);
		});
	}

}
